module.exports = __webpack_public_path__ + "static/media/foot-before-after.73dbad21.jpg";